var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      ref: "button",
      staticClass: "button",
      class: _vm.buttonClass,
      attrs: { type: "button", disabled: _vm.disabled },
      on: {
        click: function ($event) {
          $event.stopPropagation()
          return _vm.$emit("click")
        },
      },
    },
    [
      _vm.icon
        ? _c("icon", { attrs: { name: _vm.icon, size: _vm.iconSize } })
        : _vm._e(),
      _c("span", [_vm._v(_vm._s(_vm.label))]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }